<ion-accordion-group *ngIf="filterFreeTexts(freeTexts).length" value="first">
  <ion-accordion toggleIconSlot="start" value="first">
    <ion-item slot="header" color="light">
      <ion-label>
        <strong translate>Mobile.CFreeText</strong>
      </ion-label>
    </ion-item>
    <div slot="content">
      <ion-item>
        <ion-icon slot="start" size="large" src="assets/icons/unit-resources/resource-fire-fighter.svg"></ion-icon>
        <ion-label class="ion-text-wrap">
          <ng-container *ngFor="let freeText of filterFreeTexts(freeTexts)">
            <h2>
              <strong>
                {{ 'Mobile.CFreeText_' + freeText.FreeTextType | translate }}
              </strong>
            </h2>
            <h2>
              {{ freeText.LinkedResourceName }}
            </h2>
          </ng-container>
        </ion-label>
      </ion-item>
    </div>
  </ion-accordion>
</ion-accordion-group>
